// Generated by ReScript, PLEASE EDIT WITH CARE


function importCss(param) {
  return (require(`PricingDashboardAssets/styles/_pricing-dashboard-main.scss`));
}

function getImage(name) {
  var requireImage = (function(name){
        return require(`PricingDashboardAssets/images/${name}`).default
      });
  return requireImage(name);
}

export {
  importCss ,
  getImage ,
  
}
/* No side effect */
